<template lang="pug">
v-row(no-gutters class="justify-space-between").mb-3.mt-n7
    v-col(cols="6")
        v-pagination(
        v-if="length > 0"
        v-model="currentPage"
        :length="length"
        )
    v-col(v-if="resultsCount && resultsCount > 0" cols="3")
        div.text-body-2.text-right.mt-15
            p Showing {{ resultsCount.toLocaleString() }} results
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("search", ["resultsCount", "resultsPerPage"]),
    length: {
      get() {
        return Math.trunc(this.resultsCount / this.resultsPerPage) > 100
          ? 100
          : Math.trunc(this.resultsCount / this.resultsPerPage);
      },
    },
    currentPage: {
      get() {
        return this.$store.state["search"].currentPage;
      },
      set(value) {
        this.$store.dispatch("search/setCurrentPage", value);
      },
    },
  },
};
</script>

<style>
.v-pagination {
    justify-content: left !important
}
</style>